<template>
<div>
    <div class="help_Info_right fr">
        <div class="help_Info_right_top fl">
            验货签收
        </div>
        <div class="help_Info_right_bootm shoppstep fl">
            <dl>
                <dt>验货签收</dt>
                <dd>1)西始按照约定发货后，收货人有及时收货的义务。收货人可以本人签收商品或他人（包括门卫）代为签收商品，他人的签收视为收货人本人签收。签收即代表收货人对商品无异议。</dd>
                <dd>2)验货签收时，需注意以下事项：</dd>
                <dd>a.收货人务必在配送人员面前，确认货物未被拆封、无破损的情况后再签收。如外包装有挤压、变形、破损或被拆封等损坏迹象，您可拒收该货品，并及时通知西始相关人员进行处理。如您签收有明显损坏迹象的外包装后再投诉，恕我们不能受理。</dd>
                <dd>b.如货物外箱贴有易碎标识，请务必当场开箱验货，若签收后发现货物破损，我们将不再受理关于此货物有误或有损坏的投诉。</dd>
                <dd>c.如签收时发现货物有损坏，或货物与购买订单中不符，您可拒收。</dd>
                <dd>d.在未签收并当面验货的情况下，发现货物有损，可在快递面单上注明“外包装损坏，**产品破损”，“内件损坏，本人拒收”等具体破损情况，再联系西始客服，以便我司后续理赔处理；若拒签，由物流公司返回西始，请拒签后第一时间联系西始售后人员进行相关处理。</dd>
                <dd>e.若出现以上问题，请在收到货物后48小时内与西始联系。另外，为了更好保障您的权益，请在验货签收时保留商品破损的相关证明及资料（如视频、照片等）。</dd>
            </dl>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "sign"
};
</script>

<style>
</style>
